import React from 'react';
import axios from 'axios'; // Import axios
import { useLocation } from 'react-router-dom';
import './Cart.css';

function Cart({ cart, setCart }) {
  const location = useLocation();
  const product = location.state?.product;

  const immediatePurchaseProduct = product ? [product] : [];
  const allCartItems = [...cart, ...immediatePurchaseProduct];
  const total = allCartItems.reduce(
    (sum, item) => sum + item.price * (item.quantity || 1),
    0
  );

  // Function to clear the cart
  const handleClearCart = () => {
    setCart([]); // Clear the cart by setting it to an empty array
    alert('Cart has been cleared!'); // Notify the user
  };

  // Function to handle checkout
  const handleCheckout = async () => {
    console.log('Items to checkout:', allCartItems);
    try {
      const response = await axios.post('https://meow-garden-backend.onrender.com/api/orders', {
        items: allCartItems,
        total,
      });
      alert(response.data.message); // Display success message
      console.log('Order data:', response.data.order); // Log order data

      // Clear the cart after successful checkout
      handleClearCart();
    } catch (error) {
      console.error('Error placing order:', error);
      alert('Failed to place order. Please try again.');
    }
  };

  return (
    <div className="Cart">
      <div style={{ padding: '20px', backgroundColor: 'rgba(0, 0, 0, 0.6)', borderRadius: '10px' }}>
        <h1>您的商品</h1>
        {allCartItems.length === 0 ? (
          <p>Your cart is empty.</p>
        ) : (
          <>
            <ul style={{ listStyleType: 'none', padding: 0 }}>
              {allCartItems.map((item, index) => (
                <li
                  key={index}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    marginBottom: '15px',
                    borderBottom: '1px solid white',
                    paddingBottom: '10px',
                  }}
                >
                  <img
                    src={item.image}
                    alt={item.name}
                    style={{ width: '100px', height: '100px', marginRight: '20px', borderRadius: '5px' }}
                  />
                  <div>
                    <p style={{ margin: 0, fontSize: '18px', fontWeight: 'bold' }}>{item.name}</p>
                    <p style={{ margin: 0 }}>Quantity: {item.quantity || 1}</p>
                    <p style={{ margin: 0 }}>Price: ${item.price.toFixed(2)}</p>
                    <p style={{ margin: 0 }}>Total: ${(item.price * (item.quantity || 1)).toFixed(2)}</p>
                  </div>
                </li>
              ))}
            </ul>
            <h2>Total: ${total.toFixed(2)}</h2>
            <button
              style={{
                padding: '10px 20px',
                fontSize: '16px',
                color: 'white',
                backgroundColor: '#d9534f',
                border: 'none',
                borderRadius: '5px',
                cursor: 'pointer',
                marginTop: '20px',
              }}
              onClick={handleCheckout}
            >
              Checkout
            </button>
            <button
              style={{
                padding: '10px 20px',
                fontSize: '16px',
                color: 'white',
                backgroundColor: '#5bc0de',
                border: 'none',
                borderRadius: '5px',
                cursor: 'pointer',
                marginTop: '10px',
              }}
              onClick={handleClearCart}
            >
              Clear Cart
            </button>
          </>
        )}
      </div>
    </div>
  );
}

export default Cart;